/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupCompany } from './GroupCompany';
import {
    GroupCompanyFromJSON,
    GroupCompanyFromJSONTyped,
    GroupCompanyToJSON,
    GroupCompanyToJSONTyped,
} from './GroupCompany';

/**
 * PG連携会社更新リクエスト
 * @export
 * @interface UpdateCompaniesRequest
 */
export interface UpdateCompaniesRequest {
    /**
     * PG連携会社
     * @type {Array<GroupCompany>}
     * @memberof UpdateCompaniesRequest
     */
    companies?: Array<GroupCompany>;
}

/**
 * Check if a given object implements the UpdateCompaniesRequest interface.
 */
export function instanceOfUpdateCompaniesRequest(value: object): value is UpdateCompaniesRequest {
    return true;
}

export function UpdateCompaniesRequestFromJSON(json: any): UpdateCompaniesRequest {
    return UpdateCompaniesRequestFromJSONTyped(json, false);
}

export function UpdateCompaniesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompaniesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companies': json['companies'] == null ? undefined : ((json['companies'] as Array<any>).map(GroupCompanyFromJSON)),
    };
}

export function UpdateCompaniesRequestToJSON(json: any): UpdateCompaniesRequest {
    return UpdateCompaniesRequestToJSONTyped(json, false);
}

export function UpdateCompaniesRequestToJSONTyped(value?: UpdateCompaniesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companies': value['companies'] == null ? undefined : ((value['companies'] as Array<any>).map(GroupCompanyToJSON)),
    };
}

